function HomeCtrl() {

  // ViewModel
  const vm = this;
  vm.title = 'Awesome!!!';
}

export default {
  name: 'HomeCtrl',
  fn: HomeCtrl
};
